import { render, staticRenderFns } from "./menu-rest-home-sale-resident.vue?vue&type=template&id=508decee&"
import script from "./menu-rest-home-sale-resident.vue?vue&type=script&lang=js&"
export * from "./menu-rest-home-sale-resident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports